<template>
  <authorization permissionKey="configuration_facilitator_medicine" can="read">
    <v-container fluid>
      <v-row>
        <v-col class="text-h3 gray--text">
          Medicamentos
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-tabs background-color="transparent" color="secondary">
            <v-tab to="/configuracoes/medicamento">Medicamentos</v-tab>
            <v-tab to="/configuracoes/medicamento/vias-aplicacao">Vias de aplicação</v-tab>
            <v-tab to="/configuracoes/medicamento/apresentacao">Apresentações</v-tab>
          </v-tabs>
        </v-col>
      </v-row>

      <router-view />
    </v-container>
  </authorization>
</template>

<script>
  export default {
    name: "MedicineConfig",
  };
</script>

<style lang="scss" scoped></style>
